export default "__VITE_ASSET__e23c4547__"